import React from "react";
import CareerForm from "../components/CareerForm";
const Career = () => {
  return (
    <div>
      <CareerForm />
    </div>
  );
};

export default Career;
